import type { SectionNavContent } from "../types";

export const sectionNav: SectionNavContent = {
  ariaLabel: "Sektioner på siden",
  labels: {
    hero: "Oversigt",
    consortium: "Konsortium",
    platform: "Platform",
    "works-for": "Virker for",
    features: "Funktioner",
    security: "Datasikkerhed",
    models: "Modeller",
    resources: "Ressourcer",
    faq: "FAQ",
    contact: "Kontakt",
  },
};
